/** "12,50" / "12.5" / "12" → kuruş ("1250"); geçersizse null. Para hiçbir yerde float'a çevrilmez. */
export function parseEuroToMinor(input: string): string | null {
  const s = input.trim().replace(/\s/g, "").replace("€", "");
  const m = /^(\d{1,7})(?:[.,](\d{1,2}))?$/.exec(s);
  if (!m) return null;
  const cents = (m[2] ?? "").padEnd(2, "0");
  return String(BigInt(m[1]!) * 100n + BigInt(cents || "0"));
}

/** "50" / "12,5" / "%15" → bps (5000); 0–100 dışında ya da geçersizse null */
export function parsePct(input: string): number | null {
  const m = /^(\d{1,3})(?:[.,](\d{1,2}))?$/.exec(input.trim().replace("%", ""));
  if (!m) return null;
  const bps = Number(m[1]) * 100 + Number((m[2] ?? "").padEnd(2, "0") || 0);
  return bps <= 10000 ? bps : null;
}
